import React, { useState, useEffect } from 'react';
import Divider from '@mui/material/Divider';
import FormGroup from '@mui/material/FormGroup';
import TR from './../../Trans';
import MenuItem from '@mui/material/MenuItem';
import ContentContainer from './../items/ContentContainer';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Waiting from './../items/Waiting';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import MuvikaService from '../../services/muvika';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import PinQuestion from '../dialogs/PinQuestion';
import { Views } from './../../enums/enums';
import navigationStore from '../../stores/navigation';
import environmentStore from './../../stores/environment';
import accountStore from '../../stores/account';
import sessionStore from './../../stores/session';
import messageStore from './../../stores/message';
import settingsStore from '../../stores/settings';

const pinAttemptTimeout = 60 * 1000;

function ChangePassword() {

  const goToView = navigationStore((state) => state.goToView);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const account = accountStore((state) => state.account);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const changePassword = accountStore((state) => state.changePassword);
  const getAccount = accountStore((state) => state.getAccount);
  const setError = messageStore((state) => state.setError);
  const clearVerifications = accountStore((state) => state.clearVerifications);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword1, setShowNewPassword1] = useState(false);
  const [showNewPassword2, setShowNewPassword2] = useState(false);

  const [isPinQuestionOpen, setIsPinQuestionOpen] = useState(true);
  const [isPinChecked, setIsPinChecked] = useState(false);

  const [wrongPinAttempts, setWrongPinAttempts] = useState(0);
  const timeoutPinAttempts = () => { 
    setTimeout(() => setWrongPinAttempts(0), pinAttemptTimeout);
  };

  useEffect(() => { 
    if (!settings) {
      getSettings(sessionToken);
    }
    getAccount(sessionToken);
    clearVerifications();
  }, []);

  const handleCheckPin = (pin) => {
if (pin === settings.account_pin) {
      setIsPinChecked(true);
    } else {
      if (wrongPinAttempts == 0) {
        timeoutPinAttempts();
      }
      if (wrongPinAttempts >= 4) {
        setError(sessionToken, 0, TR.cm_too_many_failed_attempts_try_later);
      } else {
        setError(sessionToken, 0, TR.cm_invalid_pin);
      }
      setWrongPinAttempts(wrongPinAttempts + 1);
    }
  };

  const handleOpenPinQuestion = () => { 
    setIsPinQuestionOpen(true);
  };

  const handleClosePinQuestion = () => { 
    setIsPinQuestionOpen(false);
    goToView(Views.Home);
  };

  const handleChangePassword = () => { 
    if (oldPassword.length == 0 ||
      newPassword1.length == 0 ||
      newPassword2.length == 0) {
      setError(sessionToken, 0, TR.cm_fill_all_fields);
      return;
    }
    if (newPassword1.length >= 8) {
      if (newPassword1 === newPassword2) {
        MuvikaService.changePassword(sessionToken, account.username, oldPassword, newPassword1)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              messageStore.getState().setMessage(sessionToken, TR.ww_password_changed);
              setOldPassword("");
              setNewPassword1("");
              setNewPassword2("");
            }
          })
          .catch(function () { });
      } else {
        setError(sessionToken, 0, TR.ww_passwords_must_match);
      }
    } else {
      setError(sessionToken, 0, TR.ww_password_too_short);
    }
  };

  const renderForm = () => { 
    if (account) {
      return <div>
        <InputLabel>{TR.cm_current_password}</InputLabel>
        <OutlinedInput
          id="old-password"
          variant="outlined"
          margin="normal"
          required
          size="small"
          fullWidth
          value={oldPassword}
          notched={false}
          label={TR.cm_current_password}
          onChange={(e) => setOldPassword(e.target.value)}
          type={showOldPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowOldPassword(!showOldPassword)}
                onMouseDown={() => setShowOldPassword(!showOldPassword)}
                edge="end"
              >
                {showOldPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <InputLabel>{TR.cm_new_password}</InputLabel>
        <OutlinedInput
          id="new-password1"
          variant="outlined"
          margin="normal"
          required
          size="small"
          fullWidth
          value={newPassword1}
          notched={false}
          label={TR.cm_new_password_again}
          onChange={(e) => setNewPassword1(e.target.value)}
          type={showNewPassword1 ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowNewPassword1(!showNewPassword1)}
                onMouseDown={() => setShowNewPassword1(!showNewPassword1)}
                edge="end"
              >
                {showNewPassword1 ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <InputLabel>{TR.cm_new_password_again}</InputLabel>
        <OutlinedInput
          id="new-password2"
          variant="outlined"
          margin="normal"
          size="small"
          required
          fullWidth
          value={newPassword2}
          notched={false}
          label={TR.cm_new_password_again}
          onChange={(e) => setNewPassword2(e.target.value)}
          type={showNewPassword2 ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowNewPassword2(!showNewPassword2)}
                onMouseDown={() => setShowNewPassword2(!showNewPassword2)}
                edge="end"
              >
                {showNewPassword2 ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <Button
          fullWidth
          color="success"
          variant="text"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => { 
            handleChangePassword();
          }}>{TR.cm_change}</Button>
      </div>;
    }
  };

  const renderPinDialogOrForm = () => { 
    if (settings) {
      if (settings.account_pin && !isPinChecked) {
        return <PinQuestion open={isPinQuestionOpen} onClose={handleClosePinQuestion} onCheckPin={handleCheckPin} />;
      } else {
        return <div>
          <h3>{TR.cm_change_password}</h3>
          {renderForm()}
        </div>;
      }
    }
  };

  return (
    <div>
      {renderPinDialogOrForm()}
    </div>
  );
}

export default ChangePassword;